import angular from 'angular';

/* @ngInject */
export function WizardController (
	$timeout: ng.ITimeoutService,
	$q: ng.IQService,
	$log: ng.ILogService,
	Wizard,
	$scope,
	appData
) {
	const vm = this;

	vm.$onInit = () => {
		vm.wizard = new Wizard(vm.views);

		vm.isContentLoaded = false;
		vm.isContentValid = true;
		vm.lmsName = appData.lmsName;

		vm.wizard.onStart((view) => {
			// TODO: For now just reset these values,
			// later we should have them attached
			// to the current view.
			vm.isContentLoaded = false;
			vm.isContentValid = true;

			$timeout(() => {
				vm.onStart({view});
			});
		});

		vm.wizard.onRevisit((view) => {
			vm.onRevisit({view});
			$timeout(() => {});
		});

		vm.wizard.onEnd((view) => {
			vm.setContentLoaded(false);
			vm.onEnd({view});
			$timeout(() => {});
		});

		vm.wizard.result.then(() => {
			$timeout(() => {
				vm.onComplete();
			});
		});
	};

	vm.hasNext = () => {
		return vm.wizard.hasNext();
	};

	vm.next = () => {
		vm.wizard.next();
	};

	vm.hasPrev = () => {
		return vm.wizard.hasPrev();
	};

	vm.prev = () => {
		vm.wizard.prev();
	};

	vm.onSubmit = () => {
		const hasNext = vm.wizard.hasNext();
		const onBeforeLeave = vm.wizard.currentView.onBeforeLeave ?? angular.noop;
		const onEnd = vm.wizard.currentView.onEnd ?? angular.noop;

		return $q.when(onBeforeLeave())
			.then(() => $q.when(onEnd()))
			.then(() => {
				if (hasNext) {
					vm.next();
				} else {
					vm.finish();
				}
			}).catch((e) => {
				$log.error('WizardController.onSubmit failed!', e);
			});
	};

	vm.finish = () => {
		vm.wizard.finish();
	};

	vm.setContentLoaded = (value) => {
		vm.isContentLoaded = !!value;
	};

	vm.setContentValid = (value) => {
		vm.isContentValid = !!value;
		vm.safeDigest();
	};

	vm.nextButtonEnabled = () => {
		return vm.isContentLoaded && vm.isContentValid;
	};

	vm.showPrevButton = () => {
		const prevView = vm.wizard.getPrevView();
		return prevView && !prevView.hideNextPrevButton;
	};

	vm.doneButtonEnabled = () => {
		return vm.isContentLoaded && vm.isContentValid;
	};

	vm.hideFooter = () => {
		return !!vm.wizard.currentView.hideFooter;
	};

	vm.safeDigest = () => {
		// trigger digest so button can reflect changes after ngx changes
		const phase = $scope.$root.$$phase || $scope.$$phase;
		if (!phase) {
			$scope.$digest();
		}
	};
}
